import { useMemo } from 'react';

export const getSearchPath = (query, category, sortBy, sortOrder) => {
  const searchParams = new URLSearchParams();

  if (query) searchParams.set('q', query);
  if (category) searchParams.set('category', category);
  if (sortBy) searchParams.set('sortBy', sortBy);
  if (sortOrder) searchParams.set('sortOrder', sortOrder);

  return `/busca?${searchParams.toString()}`;
};

export const useSearchPath = (query, category, sortBy, sortOrder) =>
  useMemo(() => getSearchPath(query, category, sortBy, sortOrder), [
    query,
    category,
    sortBy,
    sortOrder
  ]);
